export const environment = {
  production: true,
  client_id: 'de9f7a06-3724-4256-8f5d-1efbf59cfa78',
  app_url: 'https://qm-entitlement-acc.qm.xom.cloud',
  base_api_url: 'https://ext.apiproxyuat.exxonmobil.com/qm-ilr-entitlement/v1',
  base_api_scope: 'api://qm-ilr-entitlement-api-nonprod/access_as_user',
  base_api_swagger:
    'https://ext.apiproxyuat.exxonmobil.com/qm-ilr-entitlement/v1/swagger/v1/swagger.json',
};